// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost:8080".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 *
 * @export
 * @interface CapacityDto
 */
export interface CapacityDto {
    /**
     *
     * @type {string}
     * @memberof CapacityDto
     */
    unit?: CapacityDto.UnitEnum;
    /**
     *
     * @type {number}
     * @memberof CapacityDto
     */
    value?: number;
}

/**
 * @export
 * @namespace CapacityDto
 */
export namespace CapacityDto {
    /**
     * @export
     * @enum {string}
     */
    export enum UnitEnum {
        LITER = <any> 'LITER',
        MILLILITER = <any> 'MILLILITER'
    }
}

/**
 *
 * @export
 * @interface DiaryPageDto
 */
export interface DiaryPageDto {
    /**
     *
     * @type {string}
     * @memberof DiaryPageDto
     */
    date?: string;
    /**
     *
     * @type {Array&lt;DrinkOutDto&gt;}
     * @memberof DiaryPageDto
     */
    drinks?: Array<DrinkOutDto>;
    /**
     *
     * @type {Array&lt;MealOutDto&gt;}
     * @memberof DiaryPageDto
     */
    meals?: Array<MealOutDto>;
    /**
     *
     * @type {Array&lt;TrainingOutDto&gt;}
     * @memberof DiaryPageDto
     */
    trainings?: Array<TrainingOutDto>;
    /**
     *
     * @type {Array&lt;WaterOutDto&gt;}
     * @memberof DiaryPageDto
     */
    waters?: Array<WaterOutDto>;
}

/**
 *
 * @export
 * @interface DrinkInDto
 */
export interface DrinkInDto {
    /**
     *
     * @type {string}
     * @memberof DrinkInDto
     */
    description?: string;
    /**
     *
     * @type {Date}
     * @memberof DrinkInDto
     */
    zonedTimestamp?: Date;
}

/**
 *
 * @export
 * @interface DrinkOutDto
 */
export interface DrinkOutDto {
    /**
     *
     * @type {Date}
     * @memberof DrinkOutDto
     */
    creationDate?: Date;
    /**
     *
     * @type {string}
     * @memberof DrinkOutDto
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof DrinkOutDto
     */
    id?: string;
    /**
     *
     * @type {StorageItemOutDto}
     * @memberof DrinkOutDto
     */
    image?: StorageItemOutDto;
    /**
     *
     * @type {StorageItemOutDto}
     * @memberof DrinkOutDto
     */
    imageThumbnail?: StorageItemOutDto;
    /**
     *
     * @type {Date}
     * @memberof DrinkOutDto
     */
    lastModificationDate?: Date;
    /**
     *
     * @type {Date}
     * @memberof DrinkOutDto
     */
    zonedTimestamp?: Date;
}

/**
 *
 * @export
 * @interface InputStream
 */
export interface InputStream {
}

/**
 *
 * @export
 * @interface MealInDto
 */
export interface MealInDto {
    /**
     *
     * @type {string}
     * @memberof MealInDto
     */
    description?: string;
    /**
     *
     * @type {Date}
     * @memberof MealInDto
     */
    zonedTimestamp?: Date;
}

/**
 *
 * @export
 * @interface MealOutDto
 */
export interface MealOutDto {
    /**
     *
     * @type {Date}
     * @memberof MealOutDto
     */
    creationDate?: Date;
    /**
     *
     * @type {string}
     * @memberof MealOutDto
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof MealOutDto
     */
    id?: string;
    /**
     *
     * @type {StorageItemOutDto}
     * @memberof MealOutDto
     */
    image?: StorageItemOutDto;
    /**
     *
     * @type {StorageItemOutDto}
     * @memberof MealOutDto
     */
    imageThumbnail?: StorageItemOutDto;
    /**
     *
     * @type {Date}
     * @memberof MealOutDto
     */
    lastModificationDate?: Date;
    /**
     *
     * @type {Date}
     * @memberof MealOutDto
     */
    zonedTimestamp?: Date;
}

/**
 *
 * @export
 * @interface MeasurementInDto
 */
export interface MeasurementInDto {
    /**
     *
     * @type {number}
     * @memberof MeasurementInDto
     */
    biceps?: number;
    /**
     *
     * @type {number}
     * @memberof MeasurementInDto
     */
    chest?: number;
    /**
     *
     * @type {string}
     * @memberof MeasurementInDto
     */
    description?: string;
    /**
     *
     * @type {number}
     * @memberof MeasurementInDto
     */
    hip?: number;
    /**
     *
     * @type {number}
     * @memberof MeasurementInDto
     */
    thigh?: number;
    /**
     *
     * @type {number}
     * @memberof MeasurementInDto
     */
    waist?: number;
    /**
     *
     * @type {number}
     * @memberof MeasurementInDto
     */
    weight?: number;
    /**
     *
     * @type {Date}
     * @memberof MeasurementInDto
     */
    zonedTimestamp?: Date;
}

/**
 *
 * @export
 * @interface MeasurementOutDto
 */
export interface MeasurementOutDto {
    /**
     *
     * @type {number}
     * @memberof MeasurementOutDto
     */
    biceps?: number;
    /**
     *
     * @type {number}
     * @memberof MeasurementOutDto
     */
    chest?: number;
    /**
     *
     * @type {Date}
     * @memberof MeasurementOutDto
     */
    creationDate?: Date;
    /**
     *
     * @type {string}
     * @memberof MeasurementOutDto
     */
    description?: string;
    /**
     *
     * @type {number}
     * @memberof MeasurementOutDto
     */
    hip?: number;
    /**
     *
     * @type {string}
     * @memberof MeasurementOutDto
     */
    id?: string;
    /**
     *
     * @type {Date}
     * @memberof MeasurementOutDto
     */
    lastModificationDate?: Date;
    /**
     *
     * @type {number}
     * @memberof MeasurementOutDto
     */
    thigh?: number;
    /**
     *
     * @type {number}
     * @memberof MeasurementOutDto
     */
    waist?: number;
    /**
     *
     * @type {number}
     * @memberof MeasurementOutDto
     */
    weight?: number;
    /**
     *
     * @type {Date}
     * @memberof MeasurementOutDto
     */
    zonedTimestamp?: Date;
}

/**
 *
 * @export
 * @interface ModelFile
 */
export interface ModelFile {
    /**
     *
     * @type {boolean}
     * @memberof ModelFile
     */
    absolute?: boolean;
    /**
     *
     * @type {any}
     * @memberof ModelFile
     */
    absoluteFile?: any;
    /**
     *
     * @type {string}
     * @memberof ModelFile
     */
    absolutePath?: string;
    /**
     *
     * @type {any}
     * @memberof ModelFile
     */
    canonicalFile?: any;
    /**
     *
     * @type {string}
     * @memberof ModelFile
     */
    canonicalPath?: string;
    /**
     *
     * @type {boolean}
     * @memberof ModelFile
     */
    directory?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ModelFile
     */
    executable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ModelFile
     */
    file?: boolean;
    /**
     *
     * @type {number}
     * @memberof ModelFile
     */
    freeSpace?: number;
    /**
     *
     * @type {boolean}
     * @memberof ModelFile
     */
    hidden?: boolean;
    /**
     *
     * @type {number}
     * @memberof ModelFile
     */
    lastModified?: number;
    /**
     *
     * @type {string}
     * @memberof ModelFile
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof ModelFile
     */
    parent?: string;
    /**
     *
     * @type {any}
     * @memberof ModelFile
     */
    parentFile?: any;
    /**
     *
     * @type {string}
     * @memberof ModelFile
     */
    path?: string;
    /**
     *
     * @type {boolean}
     * @memberof ModelFile
     */
    readable?: boolean;
    /**
     *
     * @type {number}
     * @memberof ModelFile
     */
    totalSpace?: number;
    /**
     *
     * @type {number}
     * @memberof ModelFile
     */
    usableSpace?: number;
    /**
     *
     * @type {boolean}
     * @memberof ModelFile
     */
    writable?: boolean;
}

/**
 *
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     *
     * @type {string}
     * @memberof Resource
     */
    description?: string;
    /**
     *
     * @type {any}
     * @memberof Resource
     */
    file?: any;
    /**
     *
     * @type {string}
     * @memberof Resource
     */
    filename?: string;
    /**
     *
     * @type {InputStream}
     * @memberof Resource
     */
    inputStream?: InputStream;
    /**
     *
     * @type {boolean}
     * @memberof Resource
     */
    open?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Resource
     */
    readable?: boolean;
    /**
     *
     * @type {URI}
     * @memberof Resource
     */
    uri?: URI;
    /**
     *
     * @type {URL}
     * @memberof Resource
     */
    url?: URL;
}

/**
 *
 * @export
 * @interface StorageItemOutDto
 */
export interface StorageItemOutDto {
    /**
     *
     * @type {string}
     * @memberof StorageItemOutDto
     */
    contentType?: string;
    /**
     *
     * @type {string}
     * @memberof StorageItemOutDto
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof StorageItemOutDto
     */
    originalFilename?: string;
}

/**
 *
 * @export
 * @interface TrainingInDto
 */
export interface TrainingInDto {
    /**
     *
     * @type {string}
     * @memberof TrainingInDto
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof TrainingInDto
     */
    duration?: string;
    /**
     *
     * @type {string}
     * @memberof TrainingInDto
     */
    intensity?: TrainingInDto.IntensityEnum;
    /**
     *
     * @type {string}
     * @memberof TrainingInDto
     */
    type?: TrainingInDto.TypeEnum;
    /**
     *
     * @type {Date}
     * @memberof TrainingInDto
     */
    zonedTimestamp?: Date;
}

/**
 * @export
 * @namespace TrainingInDto
 */
export namespace TrainingInDto {
    /**
     * @export
     * @enum {string}
     */
    export enum IntensityEnum {
        _1 = <any> 'LEVEL_1',
        _2 = <any> 'LEVEL_2',
        _3 = <any> 'LEVEL_3',
        _4 = <any> 'LEVEL_4',
        _5 = <any> 'LEVEL_5',
        _6 = <any> 'LEVEL_6',
        _7 = <any> 'LEVEL_7',
        _8 = <any> 'LEVEL_8',
        _9 = <any> 'LEVEL_9',
        _10 = <any> 'LEVEL_10'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        GYM = <any> 'GYM',
        BIKE = <any> 'BIKE',
        RUN = <any> 'RUN',
        WALK = <any> 'WALK',
        DANCE = <any> 'DANCE',
        SWIM = <any> 'SWIM',
        FOOTBALL = <any> 'FOOTBALL',
        BASKETBALL = <any> 'BASKETBALL',
        VOLLEYBALL = <any> 'VOLLEYBALL',
        HANDBALL = <any> 'HANDBALL',
        HOCKEY = <any> 'HOCKEY'
    }
}

/**
 *
 * @export
 * @interface TrainingOutDto
 */
export interface TrainingOutDto {
    /**
     *
     * @type {Date}
     * @memberof TrainingOutDto
     */
    creationDate?: Date;
    /**
     *
     * @type {string}
     * @memberof TrainingOutDto
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof TrainingOutDto
     */
    duration?: string;
    /**
     *
     * @type {string}
     * @memberof TrainingOutDto
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof TrainingOutDto
     */
    intensity?: TrainingOutDto.IntensityEnum;
    /**
     *
     * @type {Date}
     * @memberof TrainingOutDto
     */
    lastModificationDate?: Date;
    /**
     *
     * @type {string}
     * @memberof TrainingOutDto
     */
    type?: TrainingOutDto.TypeEnum;
    /**
     *
     * @type {Date}
     * @memberof TrainingOutDto
     */
    zonedTimestamp?: Date;
}

/**
 * @export
 * @namespace TrainingOutDto
 */
export namespace TrainingOutDto {
    /**
     * @export
     * @enum {string}
     */
    export enum IntensityEnum {
        _1 = <any> 'LEVEL_1',
        _2 = <any> 'LEVEL_2',
        _3 = <any> 'LEVEL_3',
        _4 = <any> 'LEVEL_4',
        _5 = <any> 'LEVEL_5',
        _6 = <any> 'LEVEL_6',
        _7 = <any> 'LEVEL_7',
        _8 = <any> 'LEVEL_8',
        _9 = <any> 'LEVEL_9',
        _10 = <any> 'LEVEL_10'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        GYM = <any> 'GYM',
        BIKE = <any> 'BIKE',
        RUN = <any> 'RUN',
        WALK = <any> 'WALK',
        DANCE = <any> 'DANCE',
        SWIM = <any> 'SWIM',
        FOOTBALL = <any> 'FOOTBALL',
        BASKETBALL = <any> 'BASKETBALL',
        VOLLEYBALL = <any> 'VOLLEYBALL',
        HANDBALL = <any> 'HANDBALL',
        HOCKEY = <any> 'HOCKEY'
    }
}

/**
 *
 * @export
 * @interface URI
 */
export interface URI {
    /**
     *
     * @type {boolean}
     * @memberof URI
     */
    absolute?: boolean;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    authority?: string;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    fragment?: string;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    host?: string;
    /**
     *
     * @type {boolean}
     * @memberof URI
     */
    opaque?: boolean;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    path?: string;
    /**
     *
     * @type {number}
     * @memberof URI
     */
    port?: number;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    query?: string;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    rawAuthority?: string;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    rawFragment?: string;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    rawPath?: string;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    rawQuery?: string;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    rawSchemeSpecificPart?: string;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    rawUserInfo?: string;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    scheme?: string;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    schemeSpecificPart?: string;
    /**
     *
     * @type {string}
     * @memberof URI
     */
    userInfo?: string;
}

/**
 *
 * @export
 * @interface URL
 */
export interface URL {
    /**
     *
     * @type {string}
     * @memberof URL
     */
    authority?: string;
    /**
     *
     * @type {any}
     * @memberof URL
     */
    content?: any;
    /**
     *
     * @type {number}
     * @memberof URL
     */
    defaultPort?: number;
    /**
     *
     * @type {URLStreamHandler}
     * @memberof URL
     */
    deserializedFields?: URLStreamHandler;
    /**
     *
     * @type {string}
     * @memberof URL
     */
    file?: string;
    /**
     *
     * @type {string}
     * @memberof URL
     */
    host?: string;
    /**
     *
     * @type {string}
     * @memberof URL
     */
    path?: string;
    /**
     *
     * @type {number}
     * @memberof URL
     */
    port?: number;
    /**
     *
     * @type {string}
     * @memberof URL
     */
    protocol?: string;
    /**
     *
     * @type {string}
     * @memberof URL
     */
    query?: string;
    /**
     *
     * @type {string}
     * @memberof URL
     */
    ref?: string;
    /**
     *
     * @type {number}
     * @memberof URL
     */
    serializedHashCode?: number;
    /**
     *
     * @type {string}
     * @memberof URL
     */
    userInfo?: string;
}

/**
 *
 * @export
 * @interface URLStreamHandler
 */
export interface URLStreamHandler {
}

/**
 *
 * @export
 * @interface UserProfileDto
 */
export interface UserProfileDto {
    /**
     *
     * @type {boolean}
     * @memberof UserProfileDto
     */
    isAdmin?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof UserProfileDto
     */
    isDietClinicOwner?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof UserProfileDto
     */
    isNutritionist?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof UserProfileDto
     */
    isUser?: boolean;
}

/**
 *
 * @export
 * @interface WaterInDto
 */
export interface WaterInDto {
    /**
     *
     * @type {CapacityDto}
     * @memberof WaterInDto
     */
    capacity?: CapacityDto;
    /**
     *
     * @type {string}
     * @memberof WaterInDto
     */
    description?: string;
    /**
     *
     * @type {Date}
     * @memberof WaterInDto
     */
    zonedTimestamp?: Date;
}

/**
 *
 * @export
 * @interface WaterOutDto
 */
export interface WaterOutDto {
    /**
     *
     * @type {CapacityDto}
     * @memberof WaterOutDto
     */
    capacity?: CapacityDto;
    /**
     *
     * @type {Date}
     * @memberof WaterOutDto
     */
    creationDate?: Date;
    /**
     *
     * @type {string}
     * @memberof WaterOutDto
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof WaterOutDto
     */
    id?: string;
    /**
     *
     * @type {Date}
     * @memberof WaterOutDto
     */
    lastModificationDate?: Date;
    /**
     *
     * @type {Date}
     * @memberof WaterOutDto
     */
    zonedTimestamp?: Date;
}


/**
 * DiaryControllerApi - fetch parameter creator
 * @export
 */
export const DiaryControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Returns diary items for particular day.
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForDay(date: string, options: any = {}): FetchArgs {
            // verify required parameter 'date' is not null or undefined
            if (date === null || date === undefined) {
                throw new RequiredError('date','Required parameter date was null or undefined when calling getForDay.');
            }
            const localVarPath = `/api/diary/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiaryControllerApi - functional programming interface
 * @export
 */
export const DiaryControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary Returns diary items for particular day.
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForDay(date: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DiaryPageDto> {
            const localVarFetchArgs = DiaryControllerApiFetchParamCreator(configuration).getForDay(date, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DiaryControllerApi - factory interface
 * @export
 */
export const DiaryControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @summary Returns diary items for particular day.
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForDay(date: string, options?: any) {
            return DiaryControllerApiFp(configuration).getForDay(date, options)(fetch, basePath);
        },
    };
};

/**
 * DiaryControllerApi - object-oriented interface
 * @export
 * @class DiaryControllerApi
 * @extends {BaseAPI}
 */
export class DiaryControllerApi extends BaseAPI {
    /**
     *
     * @summary Returns diary items for particular day.
     * @param {} date date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryControllerApi
     */
    public getForDay(date: string, options?: any) {
        return DiaryControllerApiFp(this.configuration).getForDay(date, options)(this.fetch, this.basePath);
    }

}

/**
 * DrinkControllerApi - fetch parameter creator
 * @export
 */
export const DrinkControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Creates drink.
         * @param {DrinkInDto} drink drink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrink(drink: DrinkInDto, options: any = {}): FetchArgs {
            // verify required parameter 'drink' is not null or undefined
            if (drink === null || drink === undefined) {
                throw new RequiredError('drink','Required parameter drink was null or undefined when calling createDrink.');
            }
            const localVarPath = `/api/diary/drink`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DrinkInDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(drink || {}) : (drink || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates drink with image.
         * @param {string} drink drink
         * @param {any} image image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrinkWithImage(drink: string, image: any, options: any = {}): FetchArgs {
            // verify required parameter 'drink' is not null or undefined
            if (drink === null || drink === undefined) {
                throw new RequiredError('drink','Required parameter drink was null or undefined when calling createDrinkWithImage.');
            }
            // verify required parameter 'image' is not null or undefined
            if (image === null || image === undefined) {
                throw new RequiredError('image','Required parameter image was null or undefined when calling createDrinkWithImage.');
            }
            const localVarPath = `/api/diary/drink/with/image`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            if (drink !== undefined) {
                localVarFormParams.set('drink', drink as any);
            }

            if (image !== undefined) {
                localVarFormParams.set('image', image as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes drink.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrink(uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling deleteDrink.');
            }
            const localVarPath = `/api/diary/drink/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets drink.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrink(uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling getDrink.');
            }
            const localVarPath = `/api/diary/drink/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Updates drink.
         * @param {DrinkInDto} drinkInDto drinkInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrink(drinkInDto: DrinkInDto, uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'drinkInDto' is not null or undefined
            if (drinkInDto === null || drinkInDto === undefined) {
                throw new RequiredError('drinkInDto','Required parameter drinkInDto was null or undefined when calling updateDrink.');
            }
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling updateDrink.');
            }
            const localVarPath = `/api/diary/drink/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DrinkInDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(drinkInDto || {}) : (drinkInDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Updates drink with image.
         * @param {string} drink drink
         * @param {any} image image
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrinkWithImage(drink: string, image: any, uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'drink' is not null or undefined
            if (drink === null || drink === undefined) {
                throw new RequiredError('drink','Required parameter drink was null or undefined when calling updateDrinkWithImage.');
            }
            // verify required parameter 'image' is not null or undefined
            if (image === null || image === undefined) {
                throw new RequiredError('image','Required parameter image was null or undefined when calling updateDrinkWithImage.');
            }
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling updateDrinkWithImage.');
            }
            const localVarPath = `/api/diary/drink/{uuid}/with/image`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            if (drink !== undefined) {
                localVarFormParams.set('drink', drink as any);
            }

            if (image !== undefined) {
                localVarFormParams.set('image', image as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DrinkControllerApi - functional programming interface
 * @export
 */
export const DrinkControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary Creates drink.
         * @param {DrinkInDto} drink drink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrink(drink: DrinkInDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DrinkOutDto> {
            const localVarFetchArgs = DrinkControllerApiFetchParamCreator(configuration).createDrink(drink, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Creates drink with image.
         * @param {string} drink drink
         * @param {any} image image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrinkWithImage(drink: string, image: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DrinkOutDto> {
            const localVarFetchArgs = DrinkControllerApiFetchParamCreator(configuration).createDrinkWithImage(drink, image, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Deletes drink.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrink(uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DrinkOutDto> {
            const localVarFetchArgs = DrinkControllerApiFetchParamCreator(configuration).deleteDrink(uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Gets drink.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrink(uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DrinkOutDto> {
            const localVarFetchArgs = DrinkControllerApiFetchParamCreator(configuration).getDrink(uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Updates drink.
         * @param {DrinkInDto} drinkInDto drinkInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrink(drinkInDto: DrinkInDto, uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DrinkOutDto> {
            const localVarFetchArgs = DrinkControllerApiFetchParamCreator(configuration).updateDrink(drinkInDto, uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Updates drink with image.
         * @param {string} drink drink
         * @param {any} image image
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrinkWithImage(drink: string, image: any, uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DrinkOutDto> {
            const localVarFetchArgs = DrinkControllerApiFetchParamCreator(configuration).updateDrinkWithImage(drink, image, uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DrinkControllerApi - factory interface
 * @export
 */
export const DrinkControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @summary Creates drink.
         * @param {DrinkInDto} drink drink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrink(drink: DrinkInDto, options?: any) {
            return DrinkControllerApiFp(configuration).createDrink(drink, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates drink with image.
         * @param {string} drink drink
         * @param {any} image image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrinkWithImage(drink: string, image: any, options?: any) {
            return DrinkControllerApiFp(configuration).createDrinkWithImage(drink, image, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes drink.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrink(uuid: string, options?: any) {
            return DrinkControllerApiFp(configuration).deleteDrink(uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Gets drink.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrink(uuid: string, options?: any) {
            return DrinkControllerApiFp(configuration).getDrink(uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Updates drink.
         * @param {DrinkInDto} drinkInDto drinkInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrink(drinkInDto: DrinkInDto, uuid: string, options?: any) {
            return DrinkControllerApiFp(configuration).updateDrink(drinkInDto, uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Updates drink with image.
         * @param {string} drink drink
         * @param {any} image image
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrinkWithImage(drink: string, image: any, uuid: string, options?: any) {
            return DrinkControllerApiFp(configuration).updateDrinkWithImage(drink, image, uuid, options)(fetch, basePath);
        },
    };
};

/**
 * DrinkControllerApi - object-oriented interface
 * @export
 * @class DrinkControllerApi
 * @extends {BaseAPI}
 */
export class DrinkControllerApi extends BaseAPI {
    /**
     *
     * @summary Creates drink.
     * @param {} drink drink
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrinkControllerApi
     */
    public createDrink(drink: DrinkInDto, options?: any) {
        return DrinkControllerApiFp(this.configuration).createDrink(drink, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Creates drink with image.
     * @param {} drink drink
     * @param {} image image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrinkControllerApi
     */
    public createDrinkWithImage(drink: string, image: any, options?: any) {
        return DrinkControllerApiFp(this.configuration).createDrinkWithImage(drink, image, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Deletes drink.
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrinkControllerApi
     */
    public deleteDrink(uuid: string, options?: any) {
        return DrinkControllerApiFp(this.configuration).deleteDrink(uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Gets drink.
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrinkControllerApi
     */
    public getDrink(uuid: string, options?: any) {
        return DrinkControllerApiFp(this.configuration).getDrink(uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Updates drink.
     * @param {} drinkInDto drinkInDto
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrinkControllerApi
     */
    public updateDrink(drinkInDto: DrinkInDto, uuid: string, options?: any) {
        return DrinkControllerApiFp(this.configuration).updateDrink(drinkInDto, uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Updates drink with image.
     * @param {} drink drink
     * @param {} image image
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrinkControllerApi
     */
    public updateDrinkWithImage(drink: string, image: any, uuid: string, options?: any) {
        return DrinkControllerApiFp(this.configuration).updateDrinkWithImage(drink, image, uuid, options)(this.fetch, this.basePath);
    }

}

/**
 * MealControllerApi - fetch parameter creator
 * @export
 */
export const MealControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Creates meal.
         * @param {MealInDto} inDto inDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeal(inDto: MealInDto, options: any = {}): FetchArgs {
            // verify required parameter 'inDto' is not null or undefined
            if (inDto === null || inDto === undefined) {
                throw new RequiredError('inDto','Required parameter inDto was null or undefined when calling createMeal.');
            }
            const localVarPath = `/api/diary/meal`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MealInDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inDto || {}) : (inDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates meal with image.
         * @param {any} image image
         * @param {string} meal meal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMealWithImage(image: any, meal: string, options: any = {}): FetchArgs {
            // verify required parameter 'image' is not null or undefined
            if (image === null || image === undefined) {
                throw new RequiredError('image','Required parameter image was null or undefined when calling createMealWithImage.');
            }
            // verify required parameter 'meal' is not null or undefined
            if (meal === null || meal === undefined) {
                throw new RequiredError('meal','Required parameter meal was null or undefined when calling createMealWithImage.');
            }
            const localVarPath = `/api/diary/meal/with/image`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            if (image !== undefined) {
                localVarFormParams.set('image', image as any);
            }

            if (meal !== undefined) {
                localVarFormParams.set('meal', meal as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes meal.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeal(uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling deleteMeal.');
            }
            const localVarPath = `/api/diary/meal/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets meal.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeal(uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling getMeal.');
            }
            const localVarPath = `/api/diary/meal/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Updates meal.
         * @param {MealInDto} mealInDto mealInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeal(mealInDto: MealInDto, uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'mealInDto' is not null or undefined
            if (mealInDto === null || mealInDto === undefined) {
                throw new RequiredError('mealInDto','Required parameter mealInDto was null or undefined when calling updateMeal.');
            }
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling updateMeal.');
            }
            const localVarPath = `/api/diary/meal/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MealInDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(mealInDto || {}) : (mealInDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Updates meal with image.
         * @param {any} image image
         * @param {string} meal meal
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMealWithImage(image: any, meal: string, uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'image' is not null or undefined
            if (image === null || image === undefined) {
                throw new RequiredError('image','Required parameter image was null or undefined when calling updateMealWithImage.');
            }
            // verify required parameter 'meal' is not null or undefined
            if (meal === null || meal === undefined) {
                throw new RequiredError('meal','Required parameter meal was null or undefined when calling updateMealWithImage.');
            }
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling updateMealWithImage.');
            }
            const localVarPath = `/api/diary/meal/{uuid}/with/image`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            if (image !== undefined) {
                localVarFormParams.set('image', image as any);
            }

            if (meal !== undefined) {
                localVarFormParams.set('meal', meal as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MealControllerApi - functional programming interface
 * @export
 */
export const MealControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary Creates meal.
         * @param {MealInDto} inDto inDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeal(inDto: MealInDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MealOutDto> {
            const localVarFetchArgs = MealControllerApiFetchParamCreator(configuration).createMeal(inDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Creates meal with image.
         * @param {any} image image
         * @param {string} meal meal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMealWithImage(image: any, meal: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MealOutDto> {
            const localVarFetchArgs = MealControllerApiFetchParamCreator(configuration).createMealWithImage(image, meal, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Deletes meal.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeal(uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MealOutDto> {
            const localVarFetchArgs = MealControllerApiFetchParamCreator(configuration).deleteMeal(uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Gets meal.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeal(uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MealOutDto> {
            const localVarFetchArgs = MealControllerApiFetchParamCreator(configuration).getMeal(uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Updates meal.
         * @param {MealInDto} mealInDto mealInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeal(mealInDto: MealInDto, uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MealOutDto> {
            const localVarFetchArgs = MealControllerApiFetchParamCreator(configuration).updateMeal(mealInDto, uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Updates meal with image.
         * @param {any} image image
         * @param {string} meal meal
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMealWithImage(image: any, meal: string, uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MealOutDto> {
            const localVarFetchArgs = MealControllerApiFetchParamCreator(configuration).updateMealWithImage(image, meal, uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MealControllerApi - factory interface
 * @export
 */
export const MealControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @summary Creates meal.
         * @param {MealInDto} inDto inDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeal(inDto: MealInDto, options?: any) {
            return MealControllerApiFp(configuration).createMeal(inDto, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates meal with image.
         * @param {any} image image
         * @param {string} meal meal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMealWithImage(image: any, meal: string, options?: any) {
            return MealControllerApiFp(configuration).createMealWithImage(image, meal, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes meal.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeal(uuid: string, options?: any) {
            return MealControllerApiFp(configuration).deleteMeal(uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Gets meal.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeal(uuid: string, options?: any) {
            return MealControllerApiFp(configuration).getMeal(uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Updates meal.
         * @param {MealInDto} mealInDto mealInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeal(mealInDto: MealInDto, uuid: string, options?: any) {
            return MealControllerApiFp(configuration).updateMeal(mealInDto, uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Updates meal with image.
         * @param {any} image image
         * @param {string} meal meal
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMealWithImage(image: any, meal: string, uuid: string, options?: any) {
            return MealControllerApiFp(configuration).updateMealWithImage(image, meal, uuid, options)(fetch, basePath);
        },
    };
};

/**
 * MealControllerApi - object-oriented interface
 * @export
 * @class MealControllerApi
 * @extends {BaseAPI}
 */
export class MealControllerApi extends BaseAPI {
    /**
     *
     * @summary Creates meal.
     * @param {} inDto inDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealControllerApi
     */
    public createMeal(inDto: MealInDto, options?: any) {
        return MealControllerApiFp(this.configuration).createMeal(inDto, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Creates meal with image.
     * @param {} image image
     * @param {} meal meal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealControllerApi
     */
    public createMealWithImage(image: any, meal: string, options?: any) {
        return MealControllerApiFp(this.configuration).createMealWithImage(image, meal, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Deletes meal.
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealControllerApi
     */
    public deleteMeal(uuid: string, options?: any) {
        return MealControllerApiFp(this.configuration).deleteMeal(uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Gets meal.
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealControllerApi
     */
    public getMeal(uuid: string, options?: any) {
        return MealControllerApiFp(this.configuration).getMeal(uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Updates meal.
     * @param {} mealInDto mealInDto
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealControllerApi
     */
    public updateMeal(mealInDto: MealInDto, uuid: string, options?: any) {
        return MealControllerApiFp(this.configuration).updateMeal(mealInDto, uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Updates meal with image.
     * @param {} image image
     * @param {} meal meal
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MealControllerApi
     */
    public updateMealWithImage(image: any, meal: string, uuid: string, options?: any) {
        return MealControllerApiFp(this.configuration).updateMealWithImage(image, meal, uuid, options)(this.fetch, this.basePath);
    }

}

/**
 * MeasurementControllerApi - fetch parameter creator
 * @export
 */
export const MeasurementControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Creates measurement.
         * @param {MeasurementInDto} measurementInDto measurementInDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeasurement(measurementInDto: MeasurementInDto, options: any = {}): FetchArgs {
            // verify required parameter 'measurementInDto' is not null or undefined
            if (measurementInDto === null || measurementInDto === undefined) {
                throw new RequiredError('measurementInDto','Required parameter measurementInDto was null or undefined when calling createMeasurement.');
            }
            const localVarPath = `/api/diary/measurement`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MeasurementInDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(measurementInDto || {}) : (measurementInDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes measurement.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurement(uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling deleteMeasurement.');
            }
            const localVarPath = `/api/diary/measurement/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets measurement.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurement(uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling getMeasurement.');
            }
            const localVarPath = `/api/diary/measurement/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Updates measurement.
         * @param {MeasurementInDto} measurementInDto measurementInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeasurement(measurementInDto: MeasurementInDto, uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'measurementInDto' is not null or undefined
            if (measurementInDto === null || measurementInDto === undefined) {
                throw new RequiredError('measurementInDto','Required parameter measurementInDto was null or undefined when calling updateMeasurement.');
            }
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling updateMeasurement.');
            }
            const localVarPath = `/api/diary/measurement/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MeasurementInDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(measurementInDto || {}) : (measurementInDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementControllerApi - functional programming interface
 * @export
 */
export const MeasurementControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary Creates measurement.
         * @param {MeasurementInDto} measurementInDto measurementInDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeasurement(measurementInDto: MeasurementInDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MeasurementOutDto> {
            const localVarFetchArgs = MeasurementControllerApiFetchParamCreator(configuration).createMeasurement(measurementInDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Deletes measurement.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurement(uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MeasurementOutDto> {
            const localVarFetchArgs = MeasurementControllerApiFetchParamCreator(configuration).deleteMeasurement(uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Gets measurement.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurement(uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MeasurementOutDto> {
            const localVarFetchArgs = MeasurementControllerApiFetchParamCreator(configuration).getMeasurement(uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Updates measurement.
         * @param {MeasurementInDto} measurementInDto measurementInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeasurement(measurementInDto: MeasurementInDto, uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MeasurementOutDto> {
            const localVarFetchArgs = MeasurementControllerApiFetchParamCreator(configuration).updateMeasurement(measurementInDto, uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MeasurementControllerApi - factory interface
 * @export
 */
export const MeasurementControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @summary Creates measurement.
         * @param {MeasurementInDto} measurementInDto measurementInDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeasurement(measurementInDto: MeasurementInDto, options?: any) {
            return MeasurementControllerApiFp(configuration).createMeasurement(measurementInDto, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes measurement.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurement(uuid: string, options?: any) {
            return MeasurementControllerApiFp(configuration).deleteMeasurement(uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Gets measurement.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurement(uuid: string, options?: any) {
            return MeasurementControllerApiFp(configuration).getMeasurement(uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Updates measurement.
         * @param {MeasurementInDto} measurementInDto measurementInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeasurement(measurementInDto: MeasurementInDto, uuid: string, options?: any) {
            return MeasurementControllerApiFp(configuration).updateMeasurement(measurementInDto, uuid, options)(fetch, basePath);
        },
    };
};

/**
 * MeasurementControllerApi - object-oriented interface
 * @export
 * @class MeasurementControllerApi
 * @extends {BaseAPI}
 */
export class MeasurementControllerApi extends BaseAPI {
    /**
     *
     * @summary Creates measurement.
     * @param {} measurementInDto measurementInDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementControllerApi
     */
    public createMeasurement(measurementInDto: MeasurementInDto, options?: any) {
        return MeasurementControllerApiFp(this.configuration).createMeasurement(measurementInDto, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Deletes measurement.
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementControllerApi
     */
    public deleteMeasurement(uuid: string, options?: any) {
        return MeasurementControllerApiFp(this.configuration).deleteMeasurement(uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Gets measurement.
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementControllerApi
     */
    public getMeasurement(uuid: string, options?: any) {
        return MeasurementControllerApiFp(this.configuration).getMeasurement(uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Updates measurement.
     * @param {} measurementInDto measurementInDto
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementControllerApi
     */
    public updateMeasurement(measurementInDto: MeasurementInDto, uuid: string, options?: any) {
        return MeasurementControllerApiFp(this.configuration).updateMeasurement(measurementInDto, uuid, options)(this.fetch, this.basePath);
    }

}

/**
 * StorageControllerApi - fetch parameter creator
 * @export
 */
export const StorageControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary add
         * @param {any} multipartFile multipartFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST(multipartFile: any, options: any = {}): FetchArgs {
            // verify required parameter 'multipartFile' is not null or undefined
            if (multipartFile === null || multipartFile === undefined) {
                throw new RequiredError('multipartFile','Required parameter multipartFile was null or undefined when calling addUsingPOST.');
            }
            const localVarPath = `/api/storage`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            if (multipartFile !== undefined) {
                localVarFormParams.set('multipartFile', multipartFile as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary download
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsingGET(fileName: string, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling downloadUsingGET.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling downloadUsingGET.');
            }
            const localVarPath = `/api/storage/download/{id}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary download
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsingGET1(fileName: string, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling downloadUsingGET1.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling downloadUsingGET1.');
            }
            const localVarPath = `/api/storage/download/{id}/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getUsingGET.');
            }
            const localVarPath = `/api/storage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary serve
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serveUsingGET(fileName: string, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling serveUsingGET.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling serveUsingGET.');
            }
            const localVarPath = `/api/storage/serve/{id}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary serve
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serveUsingGET1(fileName: string, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'fileName' is not null or undefined
            if (fileName === null || fileName === undefined) {
                throw new RequiredError('fileName','Required parameter fileName was null or undefined when calling serveUsingGET1.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling serveUsingGET1.');
            }
            const localVarPath = `/api/storage/serve/{id}/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorageControllerApi - functional programming interface
 * @export
 */
export const StorageControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary add
         * @param {any} multipartFile multipartFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST(multipartFile: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StorageItemOutDto> {
            const localVarFetchArgs = StorageControllerApiFetchParamCreator(configuration).addUsingPOST(multipartFile, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary download
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsingGET(fileName: string, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = StorageControllerApiFetchParamCreator(configuration).downloadUsingGET(fileName, id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary download
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsingGET1(fileName: string, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = StorageControllerApiFetchParamCreator(configuration).downloadUsingGET1(fileName, id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StorageItemOutDto> {
            const localVarFetchArgs = StorageControllerApiFetchParamCreator(configuration).getUsingGET(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary serve
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serveUsingGET(fileName: string, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = StorageControllerApiFetchParamCreator(configuration).serveUsingGET(fileName, id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary serve
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serveUsingGET1(fileName: string, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = StorageControllerApiFetchParamCreator(configuration).serveUsingGET1(fileName, id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * StorageControllerApi - factory interface
 * @export
 */
export const StorageControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @summary add
         * @param {any} multipartFile multipartFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST(multipartFile: any, options?: any) {
            return StorageControllerApiFp(configuration).addUsingPOST(multipartFile, options)(fetch, basePath);
        },
        /**
         *
         * @summary download
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsingGET(fileName: string, id: string, options?: any) {
            return StorageControllerApiFp(configuration).downloadUsingGET(fileName, id, options)(fetch, basePath);
        },
        /**
         *
         * @summary download
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsingGET1(fileName: string, id: string, options?: any) {
            return StorageControllerApiFp(configuration).downloadUsingGET1(fileName, id, options)(fetch, basePath);
        },
        /**
         *
         * @summary get
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsingGET(id: string, options?: any) {
            return StorageControllerApiFp(configuration).getUsingGET(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary serve
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serveUsingGET(fileName: string, id: string, options?: any) {
            return StorageControllerApiFp(configuration).serveUsingGET(fileName, id, options)(fetch, basePath);
        },
        /**
         *
         * @summary serve
         * @param {string} fileName fileName
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serveUsingGET1(fileName: string, id: string, options?: any) {
            return StorageControllerApiFp(configuration).serveUsingGET1(fileName, id, options)(fetch, basePath);
        },
    };
};

/**
 * StorageControllerApi - object-oriented interface
 * @export
 * @class StorageControllerApi
 * @extends {BaseAPI}
 */
export class StorageControllerApi extends BaseAPI {
    /**
     *
     * @summary add
     * @param {} multipartFile multipartFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageControllerApi
     */
    public addUsingPOST(multipartFile: any, options?: any) {
        return StorageControllerApiFp(this.configuration).addUsingPOST(multipartFile, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary download
     * @param {} fileName fileName
     * @param {} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageControllerApi
     */
    public downloadUsingGET(fileName: string, id: string, options?: any) {
        return StorageControllerApiFp(this.configuration).downloadUsingGET(fileName, id, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary download
     * @param {} fileName fileName
     * @param {} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageControllerApi
     */
    public downloadUsingGET1(fileName: string, id: string, options?: any) {
        return StorageControllerApiFp(this.configuration).downloadUsingGET1(fileName, id, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary get
     * @param {} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageControllerApi
     */
    public getUsingGET(id: string, options?: any) {
        return StorageControllerApiFp(this.configuration).getUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary serve
     * @param {} fileName fileName
     * @param {} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageControllerApi
     */
    public serveUsingGET(fileName: string, id: string, options?: any) {
        return StorageControllerApiFp(this.configuration).serveUsingGET(fileName, id, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary serve
     * @param {} fileName fileName
     * @param {} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageControllerApi
     */
    public serveUsingGET1(fileName: string, id: string, options?: any) {
        return StorageControllerApiFp(this.configuration).serveUsingGET1(fileName, id, options)(this.fetch, this.basePath);
    }

}

/**
 * TrainingControllerApi - fetch parameter creator
 * @export
 */
export const TrainingControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Creates training.
         * @param {TrainingInDto} training training
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTraining(training: TrainingInDto, options: any = {}): FetchArgs {
            // verify required parameter 'training' is not null or undefined
            if (training === null || training === undefined) {
                throw new RequiredError('training','Required parameter training was null or undefined when calling createTraining.');
            }
            const localVarPath = `/api/diary/training`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TrainingInDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(training || {}) : (training || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes training.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTraining(uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling deleteTraining.');
            }
            const localVarPath = `/api/diary/training/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets training.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTraining(uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling getTraining.');
            }
            const localVarPath = `/api/diary/training/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Updates training.
         * @param {TrainingInDto} trainingInDto trainingInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTraining(trainingInDto: TrainingInDto, uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'trainingInDto' is not null or undefined
            if (trainingInDto === null || trainingInDto === undefined) {
                throw new RequiredError('trainingInDto','Required parameter trainingInDto was null or undefined when calling updateTraining.');
            }
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling updateTraining.');
            }
            const localVarPath = `/api/diary/training/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TrainingInDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(trainingInDto || {}) : (trainingInDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrainingControllerApi - functional programming interface
 * @export
 */
export const TrainingControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary Creates training.
         * @param {TrainingInDto} training training
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTraining(training: TrainingInDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TrainingOutDto> {
            const localVarFetchArgs = TrainingControllerApiFetchParamCreator(configuration).createTraining(training, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Deletes training.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTraining(uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TrainingOutDto> {
            const localVarFetchArgs = TrainingControllerApiFetchParamCreator(configuration).deleteTraining(uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Gets training.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTraining(uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TrainingOutDto> {
            const localVarFetchArgs = TrainingControllerApiFetchParamCreator(configuration).getTraining(uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Updates training.
         * @param {TrainingInDto} trainingInDto trainingInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTraining(trainingInDto: TrainingInDto, uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TrainingOutDto> {
            const localVarFetchArgs = TrainingControllerApiFetchParamCreator(configuration).updateTraining(trainingInDto, uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TrainingControllerApi - factory interface
 * @export
 */
export const TrainingControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @summary Creates training.
         * @param {TrainingInDto} training training
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTraining(training: TrainingInDto, options?: any) {
            return TrainingControllerApiFp(configuration).createTraining(training, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes training.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTraining(uuid: string, options?: any) {
            return TrainingControllerApiFp(configuration).deleteTraining(uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Gets training.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTraining(uuid: string, options?: any) {
            return TrainingControllerApiFp(configuration).getTraining(uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Updates training.
         * @param {TrainingInDto} trainingInDto trainingInDto
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTraining(trainingInDto: TrainingInDto, uuid: string, options?: any) {
            return TrainingControllerApiFp(configuration).updateTraining(trainingInDto, uuid, options)(fetch, basePath);
        },
    };
};

/**
 * TrainingControllerApi - object-oriented interface
 * @export
 * @class TrainingControllerApi
 * @extends {BaseAPI}
 */
export class TrainingControllerApi extends BaseAPI {
    /**
     *
     * @summary Creates training.
     * @param {} training training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingControllerApi
     */
    public createTraining(training: TrainingInDto, options?: any) {
        return TrainingControllerApiFp(this.configuration).createTraining(training, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Deletes training.
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingControllerApi
     */
    public deleteTraining(uuid: string, options?: any) {
        return TrainingControllerApiFp(this.configuration).deleteTraining(uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Gets training.
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingControllerApi
     */
    public getTraining(uuid: string, options?: any) {
        return TrainingControllerApiFp(this.configuration).getTraining(uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Updates training.
     * @param {} trainingInDto trainingInDto
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingControllerApi
     */
    public updateTraining(trainingInDto: TrainingInDto, uuid: string, options?: any) {
        return TrainingControllerApiFp(this.configuration).updateTraining(trainingInDto, uuid, options)(this.fetch, this.basePath);
    }

}

/**
 * UserProfileControllerApi - fetch parameter creator
 * @export
 */
export const UserProfileControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary getProfile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserProfileControllerApi - functional programming interface
 * @export
 */
export const UserProfileControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary getProfile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserProfileDto> {
            const localVarFetchArgs = UserProfileControllerApiFetchParamCreator(configuration).getProfileUsingGET(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UserProfileControllerApi - factory interface
 * @export
 */
export const UserProfileControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @summary getProfile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileUsingGET(options?: any) {
            return UserProfileControllerApiFp(configuration).getProfileUsingGET(options)(fetch, basePath);
        },
    };
};

/**
 * UserProfileControllerApi - object-oriented interface
 * @export
 * @class UserProfileControllerApi
 * @extends {BaseAPI}
 */
export class UserProfileControllerApi extends BaseAPI {
    /**
     *
     * @summary getProfile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileControllerApi
     */
    public getProfileUsingGET(options?: any) {
        return UserProfileControllerApiFp(this.configuration).getProfileUsingGET(options)(this.fetch, this.basePath);
    }

}

/**
 * WaterControllerApi - fetch parameter creator
 * @export
 */
export const WaterControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Creates water.
         * @param {WaterInDto} waterInDto waterInDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWater(waterInDto: WaterInDto, options: any = {}): FetchArgs {
            // verify required parameter 'waterInDto' is not null or undefined
            if (waterInDto === null || waterInDto === undefined) {
                throw new RequiredError('waterInDto','Required parameter waterInDto was null or undefined when calling createWater.');
            }
            const localVarPath = `/api/diary/water`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"WaterInDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(waterInDto || {}) : (waterInDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes water.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWater(uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling deleteWater.');
            }
            const localVarPath = `/api/diary/water/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets water.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWater(uuid: string, options: any = {}): FetchArgs {
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling getWater.');
            }
            const localVarPath = `/api/diary/water/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Updates water.
         * @param {string} uuid uuid
         * @param {WaterInDto} waterInDto waterInDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWater(uuid: string, waterInDto: WaterInDto, options: any = {}): FetchArgs {
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new RequiredError('uuid','Required parameter uuid was null or undefined when calling updateWater.');
            }
            // verify required parameter 'waterInDto' is not null or undefined
            if (waterInDto === null || waterInDto === undefined) {
                throw new RequiredError('waterInDto','Required parameter waterInDto was null or undefined when calling updateWater.');
            }
            const localVarPath = `/api/diary/water/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebase-token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-Authorization-Firebase")
					: configuration.apiKey;
                localVarHeaderParameter["X-Authorization-Firebase"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"WaterInDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(waterInDto || {}) : (waterInDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterControllerApi - functional programming interface
 * @export
 */
export const WaterControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary Creates water.
         * @param {WaterInDto} waterInDto waterInDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWater(waterInDto: WaterInDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<WaterOutDto> {
            const localVarFetchArgs = WaterControllerApiFetchParamCreator(configuration).createWater(waterInDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Deletes water.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWater(uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<WaterOutDto> {
            const localVarFetchArgs = WaterControllerApiFetchParamCreator(configuration).deleteWater(uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Gets water.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWater(uuid: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<WaterOutDto> {
            const localVarFetchArgs = WaterControllerApiFetchParamCreator(configuration).getWater(uuid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Updates water.
         * @param {string} uuid uuid
         * @param {WaterInDto} waterInDto waterInDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWater(uuid: string, waterInDto: WaterInDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<WaterOutDto> {
            const localVarFetchArgs = WaterControllerApiFetchParamCreator(configuration).updateWater(uuid, waterInDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * WaterControllerApi - factory interface
 * @export
 */
export const WaterControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         *
         * @summary Creates water.
         * @param {WaterInDto} waterInDto waterInDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWater(waterInDto: WaterInDto, options?: any) {
            return WaterControllerApiFp(configuration).createWater(waterInDto, options)(fetch, basePath);
        },
        /**
         *
         * @summary Deletes water.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWater(uuid: string, options?: any) {
            return WaterControllerApiFp(configuration).deleteWater(uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Gets water.
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWater(uuid: string, options?: any) {
            return WaterControllerApiFp(configuration).getWater(uuid, options)(fetch, basePath);
        },
        /**
         *
         * @summary Updates water.
         * @param {string} uuid uuid
         * @param {WaterInDto} waterInDto waterInDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWater(uuid: string, waterInDto: WaterInDto, options?: any) {
            return WaterControllerApiFp(configuration).updateWater(uuid, waterInDto, options)(fetch, basePath);
        },
    };
};

/**
 * WaterControllerApi - object-oriented interface
 * @export
 * @class WaterControllerApi
 * @extends {BaseAPI}
 */
export class WaterControllerApi extends BaseAPI {
    /**
     *
     * @summary Creates water.
     * @param {} waterInDto waterInDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterControllerApi
     */
    public createWater(waterInDto: WaterInDto, options?: any) {
        return WaterControllerApiFp(this.configuration).createWater(waterInDto, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Deletes water.
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterControllerApi
     */
    public deleteWater(uuid: string, options?: any) {
        return WaterControllerApiFp(this.configuration).deleteWater(uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Gets water.
     * @param {} uuid uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterControllerApi
     */
    public getWater(uuid: string, options?: any) {
        return WaterControllerApiFp(this.configuration).getWater(uuid, options)(this.fetch, this.basePath);
    }

    /**
     *
     * @summary Updates water.
     * @param {} uuid uuid
     * @param {} waterInDto waterInDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterControllerApi
     */
    public updateWater(uuid: string, waterInDto: WaterInDto, options?: any) {
        return WaterControllerApiFp(this.configuration).updateWater(uuid, waterInDto, options)(this.fetch, this.basePath);
    }

}




// WEBPACK FOOTER //
// ./src/api/generated/api.ts